<template>
  <section class="bloc-images-columns">
    <div class="column-left">
       <img v-if="content.column_left?.img_one" class="img scroll-step js-scroll-show" :src="require(`@/${content.column_left.img_one}`)">
       <img v-if="content.column_left?.img_one" class="img scroll-step js-scroll-show" :src="require(`@/${content.column_left.img_two}`)">
       <img v-if="content.column_left?.img_one" class="img scroll-step js-scroll-show" :src="require(`@/${content.column_left.img_three}`)">
    </div>
    <div class="column-right">
      <img v-if="content.column_right?.img_one" class="img scroll-step js-scroll-show" :src="require(`@/${content.column_right.img_one}`)">
    </div>
  </section>
</template>

<script>
export default {
  name: 'ImagesColumns',
  props: {
    content: {
      type: Object,
      required: true
    },
  },
}
</script>

<style lang="scss">
  .bloc-images-columns {
    width: 100vw;
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: space-between;
    background: $th-yellow;

    .column-left {
      width: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      img {
        width: calc(100% - 16px);
        height: grid(3, 2.2);
        object-fit: cover;
        margin: rem(4px) 0;

        @include media($from: small) {
          width: grid(4, 3);
          height: grid(2.75, 2);
          margin: rem(8px) 0;
        }
      }
    }

    .column-right {
      width: 50%;
      height: grid(9.75, 8);

      .img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
  }
</style>
